import axios from 'axios';
import Cookies from 'js-cookie';

const BASE_URL_BE = process.env.REACT_APP_BASE_URL_BE;

const getAuthToken = () => Cookies.get('access_token');

const getAuthHeaders = () => ({
  'Authorization': `Bearer ${getAuthToken()}`
});
export const fetchSoal = async (page = 1, per_page = 10, filters = {}) => {
  try {
    const params = new URLSearchParams();

    // Add pagination parameters to the URL
    params.append('page', page);
    params.append('per_page', per_page);

    // Conditionally add filter parameters if they have values.
    // Ensure these parameter names ('jenis_soal_id', 'id_jenis_seleksi', 'id_soal', 'search')
    // match what your backend API expects.
    if (filters.jenis_soal_id) {
      params.append('id_jenis_soal', filters.jenis_soal_id);
    }
    if (filters.id_jenis_seleksi) {
      params.append('id_jenis_seleksi', filters.id_jenis_seleksi);
    }
    if (filters.id_soal) {
      params.append('id_soal', filters.id_soal);
    }
    if (filters.search) {
      params.append('search', filters.search);
    }

    // Make the GET request to the /soal endpoint with constructed parameters
    const response = await axios.get(`${BASE_URL_BE}/soal?${params.toString()}`, {
      headers: getAuthHeaders() // Include authentication headers
    });

    // Return the response data from the API
    return response.data;
  } catch (error) {
    // Handle errors if the API request fails
    console.error("Error fetching soal:", error);
    throw error; // Re-throw the error for handling in the calling component
  }
};
export const createSoal = async (formData) => {
    try {
      const response = await axios.post(`${BASE_URL_BE}/soal`, formData, {
        headers: {
          ...getAuthHeaders(),
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      console.error("Error creating soal:", error);
      throw error;
    }
  };

// Perbaiki fungsi updateSoal dan deleteSoal
export const updateSoal = async (id_soal, formData) => {
    try {
      const response = await axios.put(`${BASE_URL_BE}/soal/${id_soal}`, formData, {
        headers: {
          ...getAuthHeaders(),
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      console.error("Error updating soal:", error);
      throw error;
    }
  };
  
  export const deleteSoal = async (id) => {
    try {
      const response = await axios.delete(`${BASE_URL_BE}/soal/${id}`, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error("Error deleting soal:", error);
      throw error;
    }
  };

  export const totalSoal = async () => {
    try {
      const response = await axios.get(`${BASE_URL_BE}/soal/total`, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error("Error deleting soal:", error);
      throw error;
    }
  };